import { ethers } from "ethers";

async function getErc20Balance(provider, walletAddr, tokenAddr) {
  const erc20abi = ["function balanceOf(address _owner) external view returns(uint256 balance)"];
  const erc20 = new ethers.Contract(tokenAddr, erc20abi, provider);
  const balance = await erc20.balanceOf(walletAddr);

  return balance;
}

async function fetchBalances(provider, walletAddr, tokens) {
  for (let i in tokens) {
    let t = tokens[i];
    t.erc20Balance = await getErc20Balance(provider, walletAddr, t.erc20Address);
    t.tokenxBalance = await getErc20Balance(provider, walletAddr, t.tokenxAddress);
  }

  return tokens;
}

export { fetchBalances };
